import type { StudentSection, University } from '../lib/types';

export const universities: University[] = [
  {
    slug: 'tgu',
    shortName: 'ТГУ',
    name: 'Томский государственный университет',
    description:
      'Классический университет с сильной наукой, крупным кампусом в центре города и большим выбором направлений.',
    fullDescription:
      'ТГУ — первый университет в азиатской части России и один из ключевых научно-образовательных центров Сибири. Университет выбирают за сильную фундаментальную подготовку, современные исследовательские лаборатории и мощную международную академическую повестку.',
    slogan: 'Классическое образование + современная наука',
    address: 'Томск, пр. Ленина и кампусные площадки в центре города',
    hasDormitory: true,
    website: 'https://www.tsu.ru',
    founded: '1878',
    image: '/university/tgu.png',
    imageAlt: 'Главный корпус Томского государственного университета',
    tags: ['Государственный', 'Классический', 'Наука'],
    directions: ['Гуманитарные науки', 'ИТ', 'Естественные науки', 'Юриспруденция'],
    values: [
      'Сильные исследовательские школы и лаборатории',
      'Широкий выбор программ — от филологии до data science',
      'Большой кампус в шаговой доступности от центра',
    ],
    studentLife: [
      'Студенческие клубы, научные общества и творческие объединения',
      'Открытые лекции, конференции и карьерные мероприятия',
      'Удобная инфраструктура для первокурсников и иногородних студентов',
    ],
    rankings: [
      {
        title: 'THE World University Rankings',
        value: 'Группа 601–800 в мире, один из сильнейших региональных вузов РФ',
        year: '2025',
        note: 'По данным новости ТГУ о публикации THE WUR 2025.',
        level: 'international',
      },
      {
        title: 'RAEX-100 (Россия)',
        value: '19 место среди лучших вузов России',
        year: '2025',
        note: 'По таблице RAEX-100 2025: Национальный исследовательский ТГУ.',
        level: 'russia',
      },
      {
        title: 'QS Subject Rankings',
        value: 'ТГУ представлен в 15 предметных рейтингах',
        year: '2025',
        note: 'По данным материала ТГУ о результатах QS 2025.',
        level: 'international',
      },
      {
        title: 'RUR World University Ranking',
        value: '172 место в мире, топ-100 по качеству преподавания',
        year: '2025',
        note: 'По данным публикаций ТГУ о результатах RUR 2025.',
        level: 'international',
      },
    ],
    detailSections: [
      {
        title: 'Академический профиль',
        items: [
          'ТГУ традиционно силён в фундаментальных и междисциплинарных программах: математика, физика, химия, биология, ИТ, гуманитарные и социальные науки.',
          'Для абитуриента это удобный формат «университета полного цикла»: можно двигаться от бакалавриата к магистратуре, аспирантуре и научным проектам без смены экосистемы.',
        ],
      },
      {
        title: 'Наука и инфраструктура',
        items: [
          'Вуз развивает исследовательскую модель: проектные команды, лаборатории, коллаборации с академическими институтами и индустрией.',
          'Кампусная среда удобна для учебы и жизни: в шаговой доступности библиотеки, учебные корпуса, пространства для мероприятий и студенческих инициатив.',
        ],
      },
      {
        title: 'Кому подойдёт',
        items: [
          'Тем, кто выбирает классический университет с большим спектром направлений и возможностью гибко строить образовательную траекторию.',
          'Тем, кому важно совмещать учебу с исследовательской и проектной деятельностью, а также участвовать в международных программах.',
        ],
      },
    ],
    galleryIdeas: [
      'Главный корпус и Университетская роща',
      'Лаборатории и научные центры',
      'Библиотека и пространства для самостоятельной работы',
      'Культурные и студенческие события',
    ],
    galleryItems: [
      {
        image: '/university/main_TGU.webp',
        alt: 'Главный корпус ТГУ',
        title: 'Главный корпус ТГУ',
        location: 'проспект Ленина, центр Томска',
        description:
          'Парадный вход и историческая архитектура — ключевая точка знакомства абитуриентов с университетом.',
      },
      {
        image: '/university/universiti_rosha_TGU.jpg',
        alt: 'Университетская роща ТГУ',
        title: 'Университетская роща',
        location: 'территория кампуса ТГУ',
        description: 'Зелёная зона отдыха и прогулок между парами, популярное место у студентов.',
      },
      {
        image: '/university/laboratoriya_TGU.webp',
        alt: 'Лаборатория',
        title: 'Лаборатория и исследовательский трек',
        location: 'учебно-научные корпуса',
        description:
          'Здесь студенты работают над проектами, публикациями и исследовательскими задачами.',
      },
    ],
  },
  {
    slug: 'tpu',
    shortName: 'ТПУ',
    name: 'Томский политехнический университет',
    description:
      'Один из ведущих инженерных вузов страны, где ценятся практика, технологии и участие в реальных проектах.',
    fullDescription:
      'ТПУ — инженерный университет с сильным прикладным профилем, проектным обучением и устойчивыми связями с промышленными компаниями. Университет часто выбирают абитуриенты, ориентированные на техническую карьеру: от энергетики и нефтегаза до ИТ и материаловедения.',
    slogan: 'Инженерная школа с практическим уклоном',
    address: 'Томск, центральные и специализированные кампусные площадки',
    hasDormitory: true,
    website: 'https://www.tpu.ru',
    founded: '1896',
    image: '/university/tpu.jpg',
    imageAlt: 'Томский политехнический университет',
    tags: ['Технический', 'Инженерный', 'Государственный'],
    directions: ['Инженерия', 'Энергетика', 'IT', 'Нефтегаз'],
    values: [
      'Прикладные направления и тесная связь с производством',
      'Современные лаборатории и инженерные центры',
      'Сильный международный и научный трек',
    ],
    studentLife: [
      'Проектные команды и технические хакатоны',
      'Карьерные дни с работодателями и стажировки',
      'Активная студенческая среда в кампусе',
    ],
    rankings: [
      {
        title: 'QS by Subject (Oil & Gas)',
        value: 'Лидер среди российских вузов по направлению Oil & Gas',
        year: '2025',
        note: 'По данным новостей ТПУ и публикаций о QS Subject Rankings.',
        level: 'international',
      },
      {
        title: 'RAEX-100 (Россия)',
        value: '12 место среди лучших вузов России',
        year: '2025',
        note: 'По таблице RAEX-100 2025: Национальный исследовательский ТПУ.',
        level: 'russia',
      },
      {
        title: 'RAEX Subject Rankings',
        value: 'Лидерские позиции ТПУ в химтехнологиях и энергетике',
        year: '2025',
        note: 'По данным новости ТПУ о предметном рейтинге RAEX.',
        level: 'russia',
      },
      {
        title: 'Репутация у работодателей',
        value: 'Высокие позиции по оценке работодателей в РФ',
        year: '2025',
        note: 'По данным публикации ТПУ о рейтинге работодателей Forbes.',
        level: 'russia',
      },
    ],
    detailSections: [
      {
        title: 'Образовательная модель',
        items: [
          'ТПУ делает акцент на инженерной практике: работа с реальными кейсами, проектные форматы, индустриальные партнерства и стажировки.',
          'Для абитуриентов это означает более раннее погружение в профессию и возможность формировать портфолио ещё в процессе обучения.',
        ],
      },
      {
        title: 'Сильные треки',
        items: [
          'Ключевые области: энергетика, нефтегаз, химическая технология, машиностроение, цифровые инженерные технологии и ИИ в промышленности.',
          'Университет развивает современную лабораторную базу и междисциплинарные программы на стыке инженерии и данных.',
        ],
      },
      {
        title: 'Карьера выпускников',
        items: [
          'У ТПУ традиционно высокая востребованность выпускников в промышленном и технологическом секторе.',
          'Если цель — инженерная карьера и быстрый вход в профессию, ТПУ часто становится одним из самых практичных вариантов в Томске.',
        ],
      },
    ],
    galleryIdeas: [
      'Учебные и исследовательские лаборатории',
      'Инженерные проектные пространства',
      'Корпуса и общежития кампуса',
      'Хакатоны и отраслевые форумы',
    ],
    galleryItems: [
      {
        image: '/university/main_TPU.webp',
        alt: 'Главный корпус ТПУ',
        title: 'Главный корпус ТПУ',
        location: 'проспект Ленина, Томск',
        description: 'Историческое здание политеха, рядом с ключевыми учебными корпусами.',
      },
      {
        image: '/university/laboratoriya_TPU.webp',
        alt: 'Инженерная лаборатория ТПУ',
        title: 'Инженерные лаборатории',
        location: 'кампус ТПУ',
        description: 'Пространство для практических занятий, моделирования и командных проектов.',
      },
      {
        image: '/university/lobshejitiya_TPU.webp',
        alt: 'Общежитие ТПУ',
        title: 'Общежития и студенческий быт',
        location: 'кампусная зона',
        description:
          'В этом блоке удобно показать условия проживания, общие зоны и сервисы для иногородних.',
      },
    ],
  },
  {
    slug: 'tusur',
    shortName: 'ТУСУР',
    name: 'Томский государственный университет систем управления и радиоэлектроники',
    description:
      'Профильный технологический вуз Томска с фокусом на IT, радиоэлектронику, связь и прикладную разработку.',
    fullDescription:
      'ТУСУР — один из самых прикладных технологических вузов Томска. Здесь сильны программы по разработке ПО, информационной безопасности, электронике и телекоммуникациям. Университет известен предпринимательской и проектной культурой, где студенты рано подключаются к инженерным и цифровым задачам.',
    slogan: 'Университет для будущих инженеров и разработчиков',
    address: 'Томск, учебные корпуса в центре и технологических кластерах города',
    hasDormitory: true,
    website: 'https://tusur.ru',
    founded: '1962',
    image: '/university/tusur.jpg',
    imageAlt: 'Главный корпус ТУСУР в Томске',
    tags: ['IT', 'Радиоэлектроника', 'Технологии'],
    directions: ['Программирование', 'Информационная безопасность', 'Электроника', 'Связь'],
    values: [
      'Сильная школа в сфере IT и инженерных технологий',
      'Прикладные навыки и проектная работа',
      'Тесная связь с технологическим бизнесом региона',
    ],
    studentLife: [
      'Хакатоны, инженерные соревнования и акселераторы',
      'Студенческие IT-сообщества и профильные клубы',
      'Активная среда для старта карьеры уже во время учебы',
    ],
    rankings: [
      {
        title: 'RAEX-100 (Россия)',
        value: '60 место среди лучших вузов России',
        year: '2025',
        note: 'По таблице RAEX-100 2025: ТУСУР.',
        level: 'russia',
      },
      {
        title: 'Приоритет-2030',
        value: 'Стабильные позиции в основной группе программы развития университетов',
        year: '2025',
        note: 'По данным официальной новости ТУСУР о защите программы развития.',
        level: 'russia',
      },
      {
        title: 'Технологическое лидерство',
        value: 'Фокус на электронику, ИИ и безопасную цифровую среду',
        year: '2025',
        note: 'По данным материалов ТУСУР о стратегических проектах 2025.',
        level: 'russia',
      },
    ],
    detailSections: [
      {
        title: 'Специализация вуза',
        items: [
          'ТУСУР подходит тем, кто планирует строить карьеру в IT, embedded-разработке, телекоме и инженерных цифровых системах.',
          'Программы ориентированы на практику: много прикладных задач, проектных дисциплин и взаимодействия с компаниями-партнёрами.',
        ],
      },
      {
        title: 'Проекты и предпринимательство',
        items: [
          'Университет развивает акселерационные треки и студенческое предпринимательство: это важно для тех, кто хочет запускать продукты во время обучения.',
          'В экосистеме ТУСУР заметен уклон в технологическое лидерство — от электроники до беспилотных и ИИ-решений.',
        ],
      },
      {
        title: 'Кому подойдёт',
        items: [
          'Абитуриентам с интересом к «железу» и софту одновременно: микроконтроллеры, связь, программирование, инфобез.',
          'Тем, кто хочет учиться в компактной технологической среде с быстрым выходом в стажировки и индустриальные проекты.',
        ],
      },
    ],
    galleryIdeas: [
      'Лаборатории электроники и связи',
      'Студенческие проектные команды',
      'Инженерные соревнования и хакатоны',
      'Кампусная инфраструктура и общежития',
    ],
    galleryItems: [
      {
        image: '/university/main_TUSUR.jpg',
        alt: 'Корпус ТУСУР',
        title: 'Учебный корпус ТУСУР',
        location: 'центр Томска',
        description: 'Здесь проходят профильные занятия по IT, электронике и телеком-направлениям.',
      },
      {
        image: '/university/auditoriya_TUSUR.png',
        alt: 'Проектная аудитория ТУСУР',
        title: 'Проектная аудитория',
        location: 'технологические площадки вуза',
        description: 'Командная работа над стартапами и инженерными решениями во время обучения.',
      },
      {
        image: '/university/sobitiya_TUSUR.jpg',
        alt: 'Студенческое событие ТУСУР',
        title: 'Хакатоны и инженерные форумы',
        location: 'университетские и партнерские площадки',
        description: 'Сюда можно добавить кадры с хакатонов, фестивалей и защиты проектов.',
      },
    ],
  },
  {
    slug: 'sibgmu',
    shortName: 'СибГМУ',
    name: 'Сибирский государственный медицинский университет',
    description:
      'Ключевой медицинский вуз региона для тех, кто выбирает карьеру в медицине, фармации и здравоохранении.',
    fullDescription:
      'СибГМУ — профильный медицинский университет с акцентом на клиническую практику, биомедицинские исследования и подготовку специалистов для системы здравоохранения. Для абитуриентов, ориентированных на медицину, это один из главных маршрутов в Томске.',
    slogan: 'Профессиональная траектория в медицину',
    address: 'Томск, клинические и учебные площадки медицинского кампуса',
    hasDormitory: true,
    website: 'https://www.ssmu.ru',
    founded: '1888',
    image: '/university/ssmu.jpg',
    imageAlt: 'Сибирский государственный медицинский университет',
    tags: ['Медицина', 'Государственный', 'Профильный'],
    directions: ['Лечебное дело', 'Педиатрия', 'Фармация', 'Стоматология'],
    values: [
      'Сильная профильная подготовка в медицине',
      'Практика и клиническая составляющая обучения',
      'Научные школы в области биомедицины и фармации',
    ],
    studentLife: [
      'Профессиональные медицинские сообщества и практикумы',
      'Научные кружки и конференции для студентов',
      'Поддержка академической и клинической траектории',
    ],
    rankings: [
      {
        title: 'RAEX-100 (Россия)',
        value: '71 место среди лучших вузов России',
        year: '2025',
        note: 'По таблице RAEX-100 2025: СибГМУ.',
        level: 'russia',
      },
      {
        title: 'Московский международный рейтинг «Три миссии университета»',
        value: 'Входит в топ-50 российских вузов-участников',
        year: '2025',
        note: 'По данным новости СибГМУ о результатах рейтинга за 2025 год.',
        level: 'international',
      },
      {
        title: 'Национальный рейтинг университетов',
        value: 'Сохраняет позиции по основным показателям',
        year: '2025',
        note: 'По данным официальной публикации СибГМУ.',
        level: 'russia',
      },
    ],
    detailSections: [
      {
        title: 'Профиль обучения',
        items: [
          'СибГМУ строит обучение на связке «теория + клиническая практика + исследовательская работа». Это особенно важно для раннего профессионального взросления будущих врачей.',
          'Вуз развивает направления в фармации, биомедицинских технологиях и клинической медицине, где требуется высокий уровень ответственности и практических навыков.',
        ],
      },
      {
        title: 'Инфраструктура и практика',
        items: [
          'Студенты вовлекаются в практику на профильных медицинских площадках, что помогает быстрее адаптироваться к будущей профессиональной среде.',
          'Университет делает ставку на симуляционное обучение и современные образовательные форматы для клинических специальностей.',
        ],
      },
      {
        title: 'Кому подойдёт',
        items: [
          'Тем, кто осознанно выбирает медицину, готов к интенсивной учебной нагрузке и долгосрочной профессиональной траектории.',
          'Тем, кто хочет совмещать классическое медицинское образование с современными биомедицинскими и исследовательскими модулями.',
        ],
      },
    ],
    galleryIdeas: [
      'Клинические базы и симуляционные классы',
      'Учебные корпуса и лаборатории',
      'Студенческие научные конференции',
      'Волонтерские медицинские проекты',
    ],
    galleryItems: [
      {
        image: 'university/main_SIBGMU.jpg',
        alt: '/university/main_SIBGMU.jpg',
        title: 'Учебный корпус и медицинские кафедры',
        location: 'медицинский кампус СибГМУ',
        description: 'Базовые учебные площадки для теоретической и практической подготовки.',
      },
      {
        image: '/university/similicioniy_SIBGMU.jpeg',
        alt: 'Симуляционный центр СибГМУ',
        title: 'Симуляционный центр',
        location: 'клиническая инфраструктура',
        description:
          'Здесь студенты отрабатывают профессиональные навыки на тренажерах и симуляторах.',
      },
      {
        image: '/university/klinic_SIBGMU.webp',
        alt: 'Студенты СибГМУ на практике',
        title: 'Клиническая практика',
        location: 'партнерские медучреждения Томска',
        description: 'Кадры практики помогают показать реальную медицинскую траекторию студента.',
      },
    ],
  },
  {
    slug: 'tgasu',
    shortName: 'ТГАСУ',
    name: 'Томский государственный архитектурно-строительный университет',
    description:
      'Профильный выбор для тех, кому интересны архитектура, строительство, транспорт и развитие городской среды.',
    fullDescription:
      'ТГАСУ — университет с акцентом на архитектуру, строительные технологии, инфраструктуру и урбанистику. Здесь ценится практический подход: проектирование, инженерные расчеты и работа с реальными задачами города.',
    slogan: 'Университет для тех, кто строит города',
    address: 'Томск, архитектурно-строительный кампус',
    hasDormitory: true,
    website: 'https://www.tsuab.ru',
    founded: '1952',
    image: '/university/tsuab.jpg',
    imageAlt: 'Томский государственный архитектурно-строительный университет',
    tags: ['Архитектура', 'Строительство', 'Городская среда'],
    directions: ['Архитектура', 'Строительство', 'Дизайн среды', 'Транспорт'],
    values: [
      'Сильные направления в архитектуре и строительстве',
      'Практико-ориентированные проектные задания',
      'Востребованные компетенции для девелопмента и инфраструктуры',
    ],
    studentLife: [
      'Проектные мастерские и профильные конкурсы',
      'Стажировки в архитектурных бюро и строительных компаниях',
      'Участие в городских и инфраструктурных инициативах',
    ],
    rankings: [
      {
        title: 'RAEX-100 (Россия)',
        value: 'Вне топ-100 RAEX-100, 2025',
        year: '2025',
        note: 'В опубликованной таблице RAEX-100 2025 вуз не представлен.',
        level: 'russia',
      },
      {
        title: 'Рейтинг трудоустройства выпускников',
        value: 'Высокий уровень трудоустройства выпускников (около 92%)',
        year: '2025',
        note: 'По данным официальной публикации ТГАСУ о государственных рейтингах трудоустройства.',
        level: 'russia',
      },
    ],
    detailSections: [
      {
        title: 'Образовательный фокус',
        items: [
          'ТГАСУ ориентирован на прикладные компетенции: от архитектурного проектирования до строительных технологий и транспортной инфраструктуры.',
          'Обучение строится вокруг реальных задач городской среды: проектные работы, расчёты, моделирование и практика.',
        ],
      },
      {
        title: 'Профессиональный выход',
        items: [
          'Выпускники востребованы в проектных бюро, девелопменте, строительных и инфраструктурных компаниях.',
          'Для будущих архитекторов и инженеров это понятная траектория: «учеба — практика — трудоустройство по профилю».',
        ],
      },
      {
        title: 'Кому подойдёт',
        items: [
          'Тем, кто хочет работать с городской средой: здания, пространства, транспорт, благоустройство.',
          'Тем, кому важен баланс творческого и инженерного подхода в одной образовательной модели.',
        ],
      },
    ],
    galleryIdeas: [
      'Архитектурные мастерские и студии',
      'Строительные лаборатории',
      'Студенческие проекты городских пространств',
      'Практика на объектах и в компаниях',
    ],
    galleryItems: [
      {
        image: '/university/main_TGASU.jpg',
        alt: 'Архитектурная студия ТГАСУ',
        title: 'Архитектурная мастерская',
        location: 'корпуса ТГАСУ',
        description: 'Место, где студенты создают проекты зданий, интерьеров и городской среды.',
      },
      {
        image: '/university/laboratoriya_TGASU.jpg',
        alt: 'Инженерная лаборатория ТГАСУ',
        title: 'Инженерные лаборатории',
        location: 'строительные кафедры',
        description:
          'Практические занятия по конструкциям, материалам и технологиям строительства.',
      },
      {
        image: '/university/praktika_TGASU.webp',
        alt: 'Практика студентов ТГАСУ',
        title: 'Практика на городских объектах',
        location: 'Томск и область',
        description:
          'Можно показать реальные объекты, где студенты проходят практику и стажировки.',
      },
    ],
  },
  {
    slug: 'tgpu',
    shortName: 'ТГПУ',
    name: 'Томский государственный педагогический университет',
    description:
      'Сильный педагогический университет для будущих учителей, психологов и специалистов гуманитарной сферы.',
    fullDescription:
      'ТГПУ — профильный педагогический университет Томска, где сильны образовательные, психологические и гуманитарные направления. Вуз подходит тем, кто строит карьеру в образовании, работе с детьми и подростками, языковой и социальной сфере.',
    slogan: 'Педагогика, психология и гуманитарная школа',
    address: 'Томск, университетские корпуса и партнерские образовательные площадки',
    hasDormitory: true,
    website: 'https://www.tspu.edu.ru',
    founded: '1902',
    image: '/university/tspu.jpg',
    imageAlt: 'Томский государственный педагогический университет',
    tags: ['Педагогика', 'Гуманитарный', 'Государственный'],
    directions: ['Педагогика', 'Психология', 'Филология', 'Иностранные языки'],
    values: [
      'Сильная подготовка педагогов и психологов',
      'Практика в школах и образовательных проектах',
      'Развитая гуманитарная среда и методическая база',
    ],
    studentLife: [
      'Педагогические отряды и волонтерские программы',
      'Творческие студии, медиа- и языковые клубы',
      'Мероприятия для развития soft skills и лидерства',
    ],
    rankings: [
      {
        title: 'RAEX-100 (Россия)',
        value: 'Вне топ-100 RAEX-100, 2025',
        year: '2025',
        note: 'В опубликованной таблице RAEX-100 2025 вуз не представлен.',
        level: 'russia',
      },
      {
        title: 'Студенческий Томск',
        value: 'Томск стабильно в числе сильнейших студенческих городов страны',
        year: '2025',
        note: 'Городская экосистема усиливает позиции педагогического образования и практики.',
        level: 'russia',
      },
    ],
    detailSections: [
      {
        title: 'Образовательная миссия',
        items: [
          'ТГПУ ориентирован на подготовку педагогов, психологов, лингвистов и специалистов социальной сферы с практической педагогической траекторией.',
          'Сильная сторона университета — методическая подготовка и работа с образовательной практикой уже с ранних курсов.',
        ],
      },
      {
        title: 'Практика и профессиональная среда',
        items: [
          'Студенты проходят практику в школах, детских центрах, образовательных проектах и социальных инициативах.',
          'Это позволяет заранее собрать профессиональное портфолио и осознанно выбрать направление карьеры: преподавание, психология, методическая работа, образовательный менеджмент.',
        ],
      },
      {
        title: 'Кому подойдёт',
        items: [
          'Тем, кто видит себя в профессиях, связанных с обучением и развитием людей.',
          'Тем, кому важна гуманитарная и социальная повестка, работа с детьми, подростками и образовательными сообществами.',
        ],
      },
    ],
    galleryIdeas: [
      'Учебные аудитории и педагогические лаборатории',
      'Практика студентов в образовательных учреждениях',
      'Языковые и творческие клубы',
      'Студенческие социальные проекты',
    ],
    galleryItems: [
      {
        image: '/university/main_TGPU.png',
        alt: 'Учебный корпус ТГПУ',
        title: 'Учебный корпус ТГПУ',
        location: 'университетский квартал Томска',
        description: 'Базовые площадки для подготовки будущих педагогов и психологов.',
      },
      {
        image: '/university/practika_TGPU.jpeg',
        alt: 'Педагогическая практика ТГПУ',
        title: 'Педагогическая практика',
        location: 'школы и образовательные центры',
        description: 'Сюда можно добавить фото реальных уроков, мероприятий и стажировок.',
      },
      {
        image: '/university/proecti_TGPU.webp',
        alt: 'Студенческие проекты ТГПУ',
        title: 'Клубы и социальные инициативы',
        location: 'кампус и городские площадки',
        description:
          'Творческие объединения, медиа и волонтерские проекты студенческого сообщества.',
      },
    ],
  },
];

export const studentSections: StudentSection[] = [
  {
    title: 'Университеты',
    description:
      'Собрали вузы Томска, чтобы быстро сравнить направления, атмосферу и ключевые особенности.',
    href: '/students/universities',
    badge: 'Основа раздела',
  },
  {
    title: 'События',
    description:
      'Афиша студенческой жизни: лекции, фестивали, ярмарки вакансий, хакатоны и встречи.',
    href: '/students/events',
    badge: 'Скоро',
  },
  {
    title: 'Гайды',
    description:
      'Полезные материалы для первокурсников: жильё, заселение, транспорт, документы и быт.',
    href: '/students/guides',
    badge: 'Полезно',
  },
  {
    title: 'Жильё',
    description: 'Подборки районов, общежитий и советы, где удобнее жить студенту в Томске.',
    href: '/students/housing',
    badge: 'Важно',
  },
];
